import React, { Component } from 'react';
import injectSheet from 'react-jss';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ListAlt from '@material-ui/icons/ListAlt';
import Done from '@material-ui/icons/Done';
import Close from '@material-ui/icons/Close';
import without from 'lodash/without';
import union from 'lodash/union';
import TranslatableIconButton from '../TranslatableIconButton';
import TranslatableButton from '../TranslatableButton';
import FullScreenModal from '../FullScreenModal';
import WorkshopCategoryList from '../../containers/WorkshopCategoryList';

const WORKSHOP_CATEGORIES = 'Workshop Categories';

const styles = theme => ({
  WorkshopCategorySelector: {
    display: 'inline-block',
  },
  workshopCategoryLabel: {
    display: 'flex',
  },
  iconButton: {
    marginRight: '-0.75rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

class WorkshopCategorySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      currentTab: WORKSHOP_CATEGORIES,
      inputValue: props.value || [],
    };
  }

  openModal = () => this.setState({ open: true })
  closeModal = () => this.setState({ open: false })
  setCurrentTab = (tabId) => () => this.setState({ currentTab: tabId })

  onChange = () => {
    this.props.onChange(this.state.inputValue);
    this.closeModal();
  }

  discardChanges = () => {
    this.setState({
      inputValue: this.props.value || [],
    });
    this.closeModal();
  }

  handleChangeState = ({ target: { checked, value } }) => {
    this.setState(currentState => ({
      inputValue: checked ? union(currentState.inputValue, [value]) : without(currentState.inputValue, value),
    }));
  }

  render() {
    const { classes } = this.props;
    const { currentTab, inputValue } = this.state;

    const tabs = {
      [WORKSHOP_CATEGORIES]: (
        <div className={classes.container}>
          <FormGroup>
            <WorkshopCategoryList
              renderItem={workshopCategory => (
                <FormControlLabel
                  key={workshopCategory.id}
                  classes={{root: classes.workshopCategoryLabel}}
                  control={
                    <Checkbox
                      checked={inputValue.includes(workshopCategory.id)}
                      onChange={this.handleChangeState}
                      value={workshopCategory.id}
                    />
                  }
                  label={workshopCategory.name}
                />
              )}
            />
          </FormGroup>
          <div className='button-panel'>
            <TranslatableButton
              onClick={this.onChange}
              leftIcon={<Done />}
              tPath="buttons.apply_changes"
            />
            <TranslatableButton
              onClick={this.discardChanges}
              leftIcon={<Close />}
              tPath="buttons.discard_changes"
            />
          </div>
        </div>
      ),
    }

    return (
      <div className={classes.WorkshopCategorySelector}>
        <TranslatableIconButton tPath="buttons.manage_workshop_categories" onClick={this.openModal} Icon={ListAlt} buttonProps={{className: classes.iconButton}} />
        {this.state.open && (
          <FullScreenModal
            tabs={tabs}
            currentTab={currentTab}
            closeModal={this.closeModal}
            setCurrentTab={this.setCurrentTab}
          />
        )}
      </div>
    );
  }

}

export default injectSheet(styles)(WorkshopCategorySelector);
